export default function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-collection/src/entries.js
// module id = ../../../../d3-collection/src/entries.js
// module chunks = 4